import styled from 'styled-components';
import AspectRatioImg from '@ingka/aspect-ratio-image';

export const AspectRatioImage = styled(AspectRatioImg)`
  background: transparent !important;
  img {
    object-fit: contain;
  }
`;

export const AspectRatioImageFill = styled(AspectRatioImg)`
  img {
    object-fit: fill;
  }
`;
